import React, { useRef, useState } from 'react';
import { requestManagementEmail } from '../../api/donorManagementApi';
import { PillButton } from '../../components/ui';
export default function ManagementEmailButton({ invitationId }: {invitationId?: string}) {
  const requestId = useRef<string | null>(null);
  const inFlight = useRef(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const send = async () => {
    if (inFlight.current) return;
    inFlight.current = true; setBusy(true);
    try {
      requestId.current ??= crypto.randomUUID();
      const result = await requestManagementEmail(requestId.current, invitationId);
      requestId.current = null;
      setMessage(['queued', 'submitted', 'delivered'].includes(result.status)
        ? 'Management email requested for the address on the invitation.'
        : 'Management email is currently unavailable. Your sharing permission has not changed.');
    } catch { setMessage('The request could not be confirmed. Please try again.'); }
    finally { setBusy(false); inFlight.current = false; }
  };
  return <div className="management-email"><PillButton variant="secondary" className="management-email__button" busy={busy} busyLabel="Requesting…" onClick={() => void send()}>Email a management link</PillButton>{message && <p role="status">{message}</p>}</div>;
}
